// Industry-specific content prompts (10 per industry)
export const INDUSTRY_PROMPTS = {
  "Construction": [
    "Showcase our latest completed project with before and after photos",
    "Share safety tips for construction workers on site",
    "Highlight our team's expertise and certifications",
    "Announce a new construction project milestone",
    "Share client testimonials and success stories",
    "Explain our sustainable building practices",
    "Show behind-the-scenes of our construction process",
    "Promote our quality materials and craftsmanship",
    "Share construction industry trends and innovations",
    "Highlight our community impact and local projects"
  ],
  "Digital Marketing": [
    "Announce exciting new product/service launch with special offer",
    "Share SEO tips to boost website ranking and traffic",
    "Showcase successful client campaign results and ROI",
    "Create engaging social media content calendar ideas",
    "Share email marketing best practices and templates",
    "Highlight the power of video marketing and storytelling",
    "Explain PPC advertising strategies for maximum conversions",
    "Share content marketing tips for brand awareness",
    "Announce webinar or online workshop on digital trends",
    "Feature case study of viral marketing campaign success",
    "Share influencer collaboration opportunities and benefits",
    "Promote free digital marketing audit or consultation",
    "Explain Google Analytics insights and data-driven decisions",
    "Share A/B testing strategies for landing page optimization",
    "Highlight social media algorithm updates and tips",
    "Create brand storytelling and authentic engagement content",
    "Share marketing automation tools and workflow tips",
    "Promote limited-time digital marketing packages",
    "Feature customer testimonials and business growth stories",
    "Share emerging digital marketing trends and predictions"
  ],
  "Medical": [
    "Share health awareness tips for preventive care",
    "Explain a common medical condition and treatment options",
    "Introduce our medical team and their specialties",
    "Share patient success stories and testimonials",
    "Promote seasonal health check-up reminders",
    "Explain the benefits of a new medical procedure",
    "Share wellness tips for healthy living",
    "Announce new medical services or equipment",
    "Educate about vaccination importance and schedule",
    "Share mental health awareness and support resources"
  ],
  "Retail": [
    "Announce new product arrivals and exclusive deals",
    "Share styling tips using our products",
    "Highlight customer favorites and best sellers",
    "Promote limited-time flash sale offers",
    "Share customer reviews and testimonials",
    "Showcase product features and benefits",
    "Create gift guide for special occasions",
    "Share behind-the-scenes of product sourcing",
    "Announce loyalty rewards program benefits",
    "Feature seasonal collection launch"
  ],
  "Technology": [
    "Announce new software feature or update",
    "Share tech tips and productivity hacks",
    "Explain how our technology solves real problems",
    "Showcase successful client implementation case study",
    "Share industry trends and future predictions",
    "Introduce our development team and culture",
    "Explain complex tech concepts in simple terms",
    "Announce product launch or beta testing",
    "Share cybersecurity tips and best practices",
    "Highlight integration capabilities with other tools"
  ],
  "Real Estate": [
    "Showcase new property listing with virtual tour",
    "Share home buying tips for first-time buyers",
    "Highlight neighborhood features and amenities",
    "Announce open house schedule and details",
    "Share market trends and property values",
    "Feature client success stories and testimonials",
    "Provide home staging and improvement tips",
    "Explain the buying or selling process step-by-step",
    "Showcase before and after renovation projects",
    "Share investment property opportunities"
  ],
  "Finance": [
    "Share financial planning tips for savings",
    "Explain investment options and strategies",
    "Provide tax-saving tips and deadlines",
    "Announce new financial products or services",
    "Share retirement planning advice",
    "Explain loan options and qualification criteria",
    "Share credit score improvement tips",
    "Provide budgeting advice for different life stages",
    "Explain insurance coverage importance",
    "Share market analysis and economic insights"
  ],
  "Education": [
    "Announce new course offerings and schedules",
    "Share study tips and learning strategies",
    "Highlight student achievements and success stories",
    "Promote upcoming workshops or webinars",
    "Share educational resources and tools",
    "Introduce faculty members and their expertise",
    "Explain admission process and requirements",
    "Share scholarship opportunities and deadlines",
    "Highlight campus facilities and resources",
    "Share career guidance and job placement success"
  ],
  "Food & Restaurant": [
    "Showcase today's special dish with mouth-watering photo",
    "Share chef's secret recipe or cooking tips",
    "Announce new menu items or seasonal offerings",
    "Highlight customer favorites and reviews",
    "Share behind-the-scenes kitchen preparation",
    "Promote special event or live music night",
    "Feature local ingredient sourcing story",
    "Share food pairing suggestions and recommendations",
    "Announce catering services and party packages",
    "Highlight dietary options (vegan, gluten-free, etc.)"
  ],
  "Fashion & Beauty": [
    "Showcase new collection arrivals and trends",
    "Share styling tips for different occasions",
    "Feature customer transformation and testimonials",
    "Promote limited edition or exclusive items",
    "Share beauty routine and skincare tips",
    "Highlight sustainable and ethical fashion choices",
    "Create outfit inspiration for seasons",
    "Share makeup tutorial or beauty hacks",
    "Announce flash sale or promotional offers",
    "Feature influencer or celebrity wearing our products"
  ],
  "Facilities Management": [
    "Showcase professional cleaning transformation photos",
    "Share facilities maintenance tips and best practices",
    "Highlight deep cleaning services and process",
    "Promote pest control solutions and prevention tips",
    "Feature eco-friendly cleaning products and methods",
    "Share client testimonials and satisfaction ratings",
    "Announce new facilities management services",
    "Highlight team expertise and certifications",
    "Share office hygiene and safety protocols",
    "Promote scheduled maintenance packages and benefits"
  ],
  "Travel & Hospitality": [
    "Showcase stunning destination photos and experiences",
    "Share travel tips and packing essentials",
    "Announce special travel packages and deals",
    "Highlight guest testimonials and reviews",
    "Feature hidden gems and local attractions",
    "Share cultural experiences and local cuisine",
    "Promote seasonal travel offers and discounts",
    "Highlight hotel amenities and services",
    "Share safety and travel guidelines",
    "Feature unique accommodation options"
  ],
  "Fitness & Wellness": [
    "Share workout routine and exercise demonstrations",
    "Provide nutrition tips and healthy recipes",
    "Highlight member transformation success stories",
    "Announce new classes or training programs",
    "Share wellness tips for mental and physical health",
    "Promote membership offers and trial classes",
    "Feature trainer profiles and specialties",
    "Share fitness motivation and goal-setting tips",
    "Highlight gym facilities and equipment",
    "Provide recovery and injury prevention advice"
  ],
  "Legal Services": [
    "Explain common legal issues and solutions",
    "Share client success stories and case results",
    "Provide legal tips for business owners",
    "Announce new practice areas or services",
    "Explain legal process and what to expect",
    "Share updates on law changes and implications",
    "Highlight attorney profiles and expertise",
    "Provide free legal resources and consultation info",
    "Share estate planning and will preparation tips",
    "Explain rights and protections in various situations"
  ],
  "E-commerce": [
    "Announce flash sale with countdown timer",
    "Share unboxing experience and product reviews",
    "Highlight best-selling products this month",
    "Promote free shipping and exclusive offers",
    "Share customer testimonials and ratings",
    "Feature product comparison and buying guide",
    "Announce new product launches and pre-orders",
    "Share shopping tips and trend forecasts",
    "Highlight hassle-free returns and guarantees",
    "Promote loyalty rewards and referral program"
  ],
  "Automotive": [
    "Showcase new vehicle models and features",
    "Share car maintenance tips and schedules",
    "Announce special financing and trade-in offers",
    "Highlight customer testimonials and reviews",
    "Feature test drive experiences and reviews",
    "Share automotive technology and safety features",
    "Promote service specials and discounts",
    "Highlight certified pre-owned vehicle benefits",
    "Share road trip tips and vehicle preparation",
    "Feature automotive industry news and trends"
  ],
  "Entertainment": [
    "Announce upcoming show or event dates",
    "Share behind-the-scenes content and rehearsals",
    "Highlight fan testimonials and experiences",
    "Promote ticket sales and early bird offers",
    "Feature cast or performer introductions",
    "Share exclusive content and sneak peeks",
    "Announce meet and greet opportunities",
    "Highlight venue features and facilities",
    "Share event highlights and recap videos",
    "Promote merchandise and special packages"
  ]
};
